import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    description: 'bulkUpdateModal.modalTitle',
    defaultMessage: 'Bulk Update: {action}',
    id: 'lE4UXX',
  },
  cancelButton: {
    description: 'ordersBulkTagModal.cancel',
    defaultMessage: 'Cancel',
    id: 'GXktIk',
  },
  updateSelectionButton: {
    description: 'bulkUpdateModal.updateSelection',
    defaultMessage: 'Update Selection',
    id: 'EwbjFX',
  },
  loadingTitle: {
    description: 'Loading tooltip title for the bulk update modal loading indicator',
    defaultMessage: 'Loading bulk update modal...',
    id: 'XjqKnn',
  },
  bulkEditErrorTitle: {
    description: 'Warning title to display when there is Rate Shopper selected for bulk update',
    defaultMessage: 'This will apply to <b>{numberOfShipments} of {numberOfTotalShipments}</b> selected shipments',
    id: 'imFNll',
  },
  bulkEditErrorDescription: {
    description: 'Warning message to display when there is Rate Shopper selected for bulk update',
    defaultMessage: 'The remaining shipments cannot be updated because they are using a Rate Shopper',
    id: 'e+Dgtf',
  },
});
